exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sort-by-selection-container {\n  flex: 1 1;\n  display: flex;\n}\n.sort-by-selection-container .ui.selection.dropdown {\n  min-height: 33px;\n  flex: 1 1;\n  min-width: 0;\n}\n\n.sort-by-selection-container .ui.inline.dropdown .dropdown.icon {\n  margin: -7px;\n  right: 16px !important;\n}\n\n.sort-by-selection-container .ui.inline.dropdown > .text {\n  top: 1px;\n  font-weight: 100;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 20px;\n}\n\n.sort-by-selection-container .ui.inline.dropdown > .menu {\n  border: none;\n}", ""]);

// exports
